export async function runWithConcurrency<T>(
    items: T[],
    worker: (item: T) => Promise<void>,
    concurrency: number
): Promise<void> {
    let currentIndex = 0;

    async function runNext(): Promise<void> {
        const index = currentIndex++;
        if (index >= items.length) return;
        try {
            await worker(items[index]);
        } catch {
            // Nothing to do - already managed in worker (statut "failed" updated)
        } finally {
            await runNext();
        }
    }

    const workers = Array.from({ length: Math.min(concurrency, items.length) }, () => runNext());
    await Promise.all(workers);
}